// src/services/reviews.service.js
import api from "@/api/axios";

export async function getReviews() {
  const response = await api.get("/reviews");
  return response.data;
}
